import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';

fetch('/config/config.json')
  .then(res => res.json())
  .then(config => {
    if (config?.appBrowserTitle) {
      document.title = config.appBrowserTitle;
    }
    if (config?.appBrowserIcon) {
      try {
        const favicon = document.getElementById('favicon');
        if (favicon) {
          favicon.href = config.appBrowserIcon;
        }
      } catch (error) {
        console.log(error);
      }
    }
    ReactDOM.render(<App config={config} />, document.getElementById('root'));
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
